import { render, staticRenderFns } from "./VendorPageTemplate.vue?vue&type=template&id=44159f37&"
import script from "./VendorPageTemplate.vue?vue&type=script&lang=js&"
export * from "./VendorPageTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports